import React from "react";

export default function FamilySection() {
  return (
    <section id="family" class="py-5 bg-family-gradient">
      <div class="container py-5">
        <div class="section-title family-title">
          <h2 class="mb-3 text-white">
            Family-Based Green Card ,{" "}
            <span style={{ fontWeight: "bold" }}>I-130</span>,{" "}
            <span style={{ fontWeight: "bold" }}>I-485</span>
          </h2>
          <p class="text-light">
            Bringing Families Together In The United States
          </p>
        </div>

        <div class="row">
          <div class="col-lg-6">
            <div class="mb-5 text-white animate-on-scroll">
              <h3 class="mb-4">Family Reunification</h3>
              <p>
                U.S. citizens and lawful permanent residents may petition for
                certain family members to immigrate to the United States.
              </p>
              <p>
                Immigration Attorney provide end-to-end assistance from petition
                filing to visa processing, ensuring your family members can join
                you in the United States as quickly as possible.
              </p>
            </div>

            <div class="animate-on-scroll">
              <h3 class="mb-4 text-white">Family Immigration Process</h3>
              <div class="process-steps">
                <div class="process-step family-step">
                  <div class="step-number">1</div>
                  <div class="step-content">
                    <h4 class="text-white">Petition Filing</h4>
                  </div>
                </div>
                <div class="process-step family-step">
                  <div class="step-number">2</div>
                  <div class="step-content">
                    <h4 class="text-white">Document & Evidence</h4>
                  </div>
                </div>
                <div class="process-step family-step">
                  <div class="step-number">3</div>
                  <div class="step-content">
                    <h4 class="text-white">Visa Processing</h4>
                  </div>
                </div>
                <div class="process-step family-step">
                  <div class="step-number">4</div>
                  <div class="step-content">
                    <h4 class="text-white">Interview Preparation</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="row">
              <div class="col-md-6 mb-4">
                <a
                  href="#requestform"
                  className="redirectToformLink"
                  aria-label="inquiry"
                >
                  <div class="family-card animate-on-scroll">
                    <i class="fas fa-heart family-card-icon"></i>
                    <h3>Spouses</h3>
                    <p>
                      Petition for your husband or wife to join you in the U.S.
                    </p>
                  </div>
                </a>
              </div>
              <div class="col-md-6 mb-4">
                <a
                  href="#requestform"
                  className="redirectToformLink"
                  aria-label="inquiry"
                >
                  <div class="family-card animate-on-scroll">
                    <i class="fas fa-hands-holding-child family-card-icon"></i>
                    <h3>Children</h3>
                    <p>
                      Bring your children to live with you in the United States
                    </p>
                  </div>
                </a>
              </div>
              <div class="col-md-6 mb-4">
                <a
                  href="#requestform"
                  className="redirectToformLink"
                  aria-label="inquiry"
                >
                  <div class="family-card animate-on-scroll">
                    <i class="fas fa-user-friends family-card-icon"></i>
                    <h3>Parents</h3>
                    <p>
                      Petition for your parents to become permanent residents
                    </p>
                  </div>
                </a>
              </div>
              <div class="col-md-6 mb-4">
                <a
                  href="#requestform"
                  className="redirectToformLink"
                  aria-label="inquiry"
                >
                  <div class="family-card animate-on-scroll">
                    <i class="fas fa-people-group family-card-icon"></i>
                    <h3>Siblings</h3>
                    <p>Family-based petitions for brothers and sisters</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
